/**
 * Pantallas de catálogo para navegación (screen-registry).
 * Separado de public-api para no cargar CatalogScreen al importar repos/helpers del módulo.
 */
export { CatalogScreen, CatalogMastersScreen } from './screens/index';
